export default {
// 模块名称
  deviceMg: {
    // 按钮类
    button: {
      add: '新增',
      delete: '删除',
      batchDelete: '批量删除',
      edit: '编辑',
      save: '保存',
      Cancel: '取消',
      confirm: '确定'
    },
    // 文字标签类
    label: {
      cameraName: '摄像机组名称',
      type: '类型',
      car: '车牌',
      people: '人脸',
      area: '区域',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '创建时间'
    },
    // 提示类
    placeholder: {
      cameraName: '请输入摄像机组名称',
      area: '请选择区域',
      startTime: '开始时间',
      endTime: '结束时间'
    },
    // 消息类
    message: {
      area: '请选择区域',
      details: '请求详情失败',
      abnormal: '请求异常',
      deleteWarn: '此操作将永久删除该摄像机组, 是否继续?',
      batchDeleteWarn: '此操作将永久批量删除所选摄像机组, 是否继续?',
      deleteSuccess: '删除成功',
      noDelete: '您还没有选择要删除的摄像机组',
      deleteFail: '删除失败',
      create: '创建成功',
      editSuccess: '修改成功',
      cameraName: '请输入摄像机组名称',
      length: '长度最少 3 个字符',
      value: '请输入中文、英文、数字组合',
      type: '请选择类型',
      coordinate: '该摄像机没有经纬度信息',
      values: '长度小于30个字符'
    },
    // 标题类
    title: {
      add: '新增',
      select: '选择',
      edit: '修改',
      remind: '提示',
      cameraList: '摄像机列表',
      startTime: '开始时间',
      endTime: '结束时间',
      choseCamera: '选择摄像机组',
      information: '暂无数据'
    }
  }
}